import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import { transformArrayToSelectOptions } from 'utils/transformArrayToSelectOptions';
import { OveitIcon } from '../OveitIcon';
import { EventFieldTypeProps } from './EventFieldSwitcher';

const ArrowDropDown = () => <OveitIcon name="arrowDropDown" size={10} />;

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDropDown />
    </components.DropdownIndicator>
  );
};

const EventFieldTypeSelect: React.FC<EventFieldTypeProps> = ({
  inputName,
  field: {
    label,
    mandatory,
    meta: { options, multiple },
  },
  disabled,
}) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <label
        className={`label-input p3-semibold element-contains-html ${
          mandatory ? 'mandatory' : ''
        }`}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      <Controller
        name={inputName}
        control={control}
        rules={{ required: { value: mandatory, message: 'requiredField' } }}
        render={({ field }) => (
          <Select
            {...field}
            name={inputName}
            isMulti={multiple === '1'}
            placeholder={t('registrationPage.choose')}
            options={transformArrayToSelectOptions(options)}
            classNamePrefix="react-select"
            className={`${errors[inputName]?.message && 'react-select-error'}`}
            components={{
              DropdownIndicator,
              IndicatorSeparator: undefined,
            }}
            isDisabled={disabled}
            isClearable
          />
        )}
      />
      {errors[inputName]?.message && (
        <p className="standard-input-error">
          {t(`inputErrors.${errors[inputName]?.message}`)}
        </p>
      )}
    </div>
  );
};

export default EventFieldTypeSelect;
